import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import AOS from "aos";
import "./assets/global.css";
import "aos/dist/aos.css";

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "oh yes world";
  next();
});

AOS.init({
  duration: 1000,
  easing: "ease-in-out",
  once: false,
});

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
